var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.16,2.98C3.29,2.98,.14,6.13,.14,10s3.15,7.02,7.02,7.02,7.02-3.15,7.02-7.02S11.03,2.98,7.16,2.98Zm-3.86,7.52c.06,.86,.24,1.63,.51,2.31-.58,.32-1.03,.66-1.35,.94-.73-.91-1.19-2.03-1.3-3.25H3.31Zm3.28,4.67c-.44-.42-.97-1.05-1.43-1.86,.43-.15,.9-.27,1.43-.32v2.18Zm1-2.19c.63,.05,1.19,.18,1.68,.37-.54,.88-1.19,1.52-1.68,1.92v-2.29Zm0-1v-1.48h2.62c-.06,.73-.23,1.38-.47,1.95-.62-.25-1.34-.43-2.15-.48Zm0-2.48v-1.62c.8-.05,1.5-.25,2.09-.52,.29,.68,.48,1.4,.54,2.14h-2.63Zm0-2.62v-2.21c.66,.51,1.2,1.12,1.63,1.8-.47,.21-1.01,.36-1.63,.4Zm.93-2.74c.88,.2,1.69,.6,2.38,1.15-.19,.2-.46,.45-.81,.7-.42-.69-.95-1.31-1.57-1.85Zm-1.93,.65v2.05c-.49-.07-.93-.21-1.31-.39,.43-.72,.91-1.27,1.31-1.66Zm-2.18,1.16c-.37-.27-.66-.55-.85-.76,.66-.5,1.43-.87,2.27-1.06-.44,.44-.96,1.05-1.42,1.82Zm2.18,1.89v1.66h-2.26c.06-.81,.24-1.53,.51-2.16,.51,.24,1.09,.42,1.76,.5Zm0,2.66v1.49c-.68,.06-1.3,.21-1.85,.41-.22-.57-.36-1.2-.42-1.9h2.26Zm-2.35,3.22c.51,.94,1.13,1.67,1.64,2.16-1.03-.23-1.96-.72-2.72-1.4,.26-.23,.62-.5,1.08-.76Zm5.94,.06c.42,.24,.75,.49,.99,.7-.77,.69-1.72,1.19-2.78,1.41,.56-.48,1.23-1.19,1.78-2.12Zm.45-.89c.3-.7,.51-1.49,.58-2.38h1.95c-.1,1.22-.57,2.34-1.3,3.25-.29-.26-.7-.57-1.23-.87Zm2.52-3.38h-1.95c-.06-.92-.29-1.81-.66-2.63,.46-.32,.82-.64,1.07-.9,.86,.95,1.42,2.18,1.54,3.53ZM2.81,5.86c.25,.28,.64,.64,1.14,.98-.34,.77-.58,1.65-.64,2.66H1.17c.12-1.41,.72-2.67,1.64-3.64Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.89,7.38h-7.62c-.31,0-.57,.25-.57,.57v4.87c0,.31,.25,.57,.57,.57h7.62c.31,0,.57-.25,.57-.57V7.95c0-.31-.25-.57-.57-.57Zm.16,5.08c0,.31-.25,.57-.57,.57h-6.8c-.31,0-.57-.25-.57-.57v-4.14c0-.31,.25-.57,.57-.57h6.8c.31,0,.57,.25,.57,.57v4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.89,13.9h-7.62c-.59,0-1.07-.48-1.07-1.07V7.95c0-.59,.48-1.07,1.07-1.07h7.62c.59,0,1.07,.48,1.07,1.07v4.87c0,.59-.48,1.07-1.07,1.07Zm-7.21-5.64l-.07,4.21,6.87,.07,.07-.07v-4.14l-6.87-.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.61,
    y: 8.25,
    width: 6.94,
    height: 4.28,
    rx: 0.57,
    ry: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.48,13.53h-6.8c-.59,0-1.07-.48-1.07-1.07v-4.14c0-.59,.48-1.07,1.07-1.07h6.8c.59,0,1.07,.48,1.07,1.07v4.14c0,.59-.48,1.07-1.07,1.07Zm-6.8-5.28l-.07,4.21,6.87,.07s.07-.03,.07-.07v-4.14l-6.87-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.52,12.09h-3.25v-3.37h3.25v3.37Zm-2.25-1h1.25v-1.37h-1.25v1.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.93,
    y: 9.22,
    width: 2.31,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.93,
    y: 10.58,
    width: 2.31,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.6df04768f4b2544fa545085fbd89ab42.svg";
export { ForwardRef as ReactComponent };